import { createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-74980fa0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card-upcom card-upcom--padding-fix card-upcom--order" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<p class=\"card-upcom__date\" data-v-74980fa0></p><div class=\"card-upcom__img\" data-v-74980fa0></div><div data-v-74980fa0><p class=\"card-upcom__desc\" data-v-74980fa0></p><div class=\"card-upcom__text\" data-v-74980fa0><p class=\"card-upcom__time\" data-v-74980fa0></p></div></div>", 3)
const _hoisted_5 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_5))
}